const normalizeUS = value => {
  if (!value) return null;
  if (value.startsWith('+1')) return value.slice(2);
  return value;
};

export default normalizeUS;
